<template>
  <v-row class="mt-8">
    <v-col cols="12" sm="8" md="9" class="d-flex align-center">
      <p
        class="primary--text request-draft-contract__title font-weight-bold mb-2"
      >
        {{ title }}
        <v-tooltip bottom content-class="tooltip-label-form">
          <template v-slot:activator="{ on }">
            <v-icon color="secondary" size="10" v-on="on" class="pl-1">
              fa-info-circle
            </v-icon>
          </template>
          <v-row>
            <v-col cols="12" class="px-4 py-3">
              <p class="white--text tooltip-label-text mb-0">
                {{ textInformation }}
              </p>
            </v-col>
          </v-row>
        </v-tooltip>
      </p>
    </v-col>
    <v-col cols="12" sm="4" md="3" class="pb-2" v-if="showButton">
      <BaseButton
        text
        color="secondary"
        class="font-weight-bold justify-end pr-0"
        @click="newItem"
        width="100%"
      >
        {{ nameButton }}
        <v-icon class="pl-2" size="20">
          fa-plus
        </v-icon>
      </BaseButton>
    </v-col>
    <v-col cols="12">
      <slot />
    </v-col>
  </v-row>
</template>
<script>
export default {
  methods: {
    newItem() {
      this.$router.push({ name: this.routeNewItem });
    }
  },
  props: {
    routeNewItem: {
      type: String,
      default: "quotation new criticism"
    },
    title: {
      type: String,
      default: "CRÍTICAS"
    },
    nameButton: {
      type: String,
      default: "REGISTRAR CRÍTICA"
    },
    showButton: {
      type: Boolean
    },
    textInformation: {
      type: String
    }
  }
};
</script>
<style lang="sass"></style>
